<script setup lang="ts">
import type { Component, MaybeRefOrGetter } from "vue";
import { computed, toValue } from "vue";

import DropdownMenuItemContent from "~/components/dumb/DropdownMenuItemContent.vue";
import Toggle from "~/components/dumb/Toggle.vue";
import { ButtonSize } from "~/shared/enums";

const props = defineProps<{
  title: string;
  icon?: Component;
  value: MaybeRefOrGetter<boolean>;
  onUpdate: (value: boolean) => void;
  disabled?: boolean;
}>();

const value = computed(() => toValue(props.value));

const toggle = () => {
  if (props.disabled) {
    return;
  }
  props.onUpdate(!value.value);
};

const stopPropagation = (event: Event) => {
  event.stopPropagation();
};
</script>

<template>
  <DropdownMenuItemContent
    class="group cursor-pointer focus-ring-none hover:bg-md focus:bg-md"
    :title="title"
    :icon="icon"
    :icon-args="{ class: 'icon-sm text-lt' }"
    :disabled="disabled"
    :icon-after="Toggle"
    :icon-after-args="{
      value,
      size: ButtonSize.SMALL,
      disabled,
      hideLabel: true,
      class: value ? undefined : 'group-hover:[&>button]:bg-hvy group-focus:[&>button]:bg-hvy',
      onClick: stopPropagation,
      onUpdate,
    }"
    @click="toggle" />
</template>
